import { makeStyles } from '@material-ui/styles'
import { Typography as Text } from 'antd'
import moment from 'moment'
import { useTranslation } from 'react-i18next'

import { useSelector } from '@/redux'

const formatDateTime = (v) => {
  const m = moment(v)
  return m.isValid() ? m.format('YYYY/MM/DD HH:mm') : '-'
}

/**
 * @param {{ start?: string, end?: string }} props
 */
export default function TaxReportHeader(props) {
  const { start, end } = props
  const classes = useStyles()
  const { t } = useTranslation()
  const activeMerchant = useSelector((state) => state.merchant.activeMerchant)
  const setting = activeMerchant?.setting ?? {}

  const ownerName = setting.eInvoiceCompanyName || '-'
  const address = activeMerchant?.address || '-'
  const restaurantName = activeMerchant?.name || '-'
  const taxpayerId = setting.taxId || '-'
  const branch = setting.isHeadquarter
    ? t('page.taxInvoiceReports.header.hq')
    : setting.branchNo || '-'

  const rows = [
    { key: 'ownerName', label: t('page.taxInvoiceReports.header.ownerName'), value: ownerName },
    { key: 'address', label: t('page.taxInvoiceReports.header.address'), value: address },
    {
      key: 'restaurantName',
      label: t('page.taxInvoiceReports.header.restaurantName'),
      value: restaurantName,
    },
    { key: 'taxpayerId', label: t('page.taxInvoiceReports.header.taxpayerId'), value: taxpayerId },
    { key: 'branch', label: t('page.taxInvoiceReports.header.branch'), value: branch },
  ]

  // if (start && end) {
  //   rows.push({
  //     key: 'dateRange',
  //     label: t('page.taxInvoiceReports.header.dateRange'),
  //     value: `${formatDateTime(start)} ~ ${formatDateTime(end)}`,
  //   })
  // }

  return (
    <div className={classes.header}>
      {rows.map((row) => (
        <div key={row.key} className={classes.row}>
          <Text className={classes.label}>{row.label}</Text>
          <Text className={classes.value}>{row.value}</Text>
        </div>
      ))}
    </div>
  )
}

const useStyles = makeStyles(() => ({
  header: {
    marginBottom: 16,
  },
  row: {
    display: 'flex',
    alignItems: 'baseline',
    marginBottom: 4,
  },
  label: {
    fontWeight: 'bold',
    minWidth: 220,
    marginRight: 8,
  },
  value: {
    flex: 1,
    wordBreak: 'break-word',
  },
}))
